import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getAuditLogsData } from '../../../redux/actions/GetAuditLogs';
import { getAuditLogsEndpoint } from '../../../common/endpoints';
import { Loader } from '../../../components/common/Loader';
import TopSection from '../../LT/TopSection'
import { DataDetails } from './DataDetails';
import { toast } from 'react-toastify';

export const AuditLogs = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const procurementDivisionType = useSelector((state) => state?.userCardType?.procurementDivisionType);
  const getAudits = useSelector((state) => state?.getAuditLogSlice?.data);

  const pagination = true;
  const paginationPageSize = 30;
  const paginationPageSizeSelector = [30, 50, 100, 500, 2000];
  const region = localStorage.getItem("CDRegion");

  const getAuditLogs = useCallback(async () => {
    setLoading(true);
    try {
      const response = await dispatch(
          getAuditLogsData({
            dynamicEndpoint: `${procurementDivisionType.toLowerCase() === 'packaging' ? `${getAuditLogsEndpoint}/${procurementDivisionType.toLowerCase()}/getAuditLogs?region=${region}` : `${getAuditLogsEndpoint}/${procurementDivisionType.toLowerCase()}/getAuditLogs`}`,
          })
        );
        if (response?.meta?.requestStatus === 'fulfilled') {
          setLoading(false);
        } else {
          setLoading(false);
          toast.error(`${response?.payload?.errorMessage}`);
          console.error('Failed to fetch data:', response.error);
        }
    } catch(error){
      setLoading(false);
      toast.error("Error fetching Audit Logs data");
      console.error("Error fetching Audit Logs data:", error);
    }
  }, [dispatch, procurementDivisionType, region]);

  useEffect(() => {
    getAuditLogs();
  }, [getAuditLogs])

  return (
    <>
        <TopSection
          labelList={[
              { title: "Home", path: "/landing-page" },
              { title: "Audit Logs" }, 
          ]}
          hideHeader={true}
          headerName={"Audit Logs"}
        />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div className="priceMemo_main">
              {loading ? (
                <Loader />
              ) : !getAudits ? (
                <div style={{ textAlign: "center", fontWeight: "bold" }}>
                  No record found
                </div>
              ) : (
                <div className="priceMemo_dataTable">
                  <DataDetails
                    pagination={pagination}
                    paginationPageSize={paginationPageSize}
                    paginationPageSizeSelector={paginationPageSizeSelector}
                    data={getAudits}
                  />
                </div>
              )}
            </div>
          </Grid>
      </Grid> 
    </>
  )
}
